import { styled } from "@mui/material";
const Root = styled("form", { name: "Form", slot: "Root" })(() => ({
  width: "100%",
  display: "flex",
  overflow: "hidden",
  position: "relative"
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
